import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { getJdInternData } from "../api/crud";
import ModalView from "../Components/ModalView";
import { optionsBranch } from "../data/branch-data";
import { matchOptions } from "../utils/function";
import { generateStatus } from "../utils/generateDisplay";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import Select from "react-select";
import xlsxParser from "xls-parser";
import { BsPencilSquare } from "react-icons/bs";
import DrawerView from "../Components/DrawerView";
import JobDetail from "../Components/JobDetail";
import { useReactToPrint } from "react-to-print";

const JobRequest = () => {
  const [lists, setLists] = useState([]);
  const [filterLists, setFilterList] = useState([]);
  const [gpaList, setGpaList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalAddOpen, setModalAddOpen] = useState(false);
  const [modalGpaPreviewOpen, setModalGpaPreviewOpen] = useState(false);
  const [itemSelected, setItemSelected] = useState(null);
  const [modalEditGpaOpen, setModalEditGpaOpen] = useState(false);
  const [openDrawerDetail, setOpenDrawerDetail] = useState(false);
  const { register, control, watch, setValue } = useForm();
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const onSearchChange = (ev) => {
    setSearchTerm(ev.target.value);

    const results = lists.filter((item) => {
      return (
        item.id.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.name.toLowerCase().includes(ev.target.value.toLowerCase()) ||
        item.branch_name?.toLowerCase().includes(ev.target.value.toLowerCase())
      );
    });

    setFilterList(results);
  };

  const onOpenDetail = (item) => {
    setOpenDrawerDetail(true);
    setItemSelected(item);
  };

  // const onEditGpa = (item) => {
  //   setModalEditGpaOpen(true);
  //   setItemSelected(item);

  //   setValue("edit.id", item.id);
  //   setValue("edit.name", item.name);
  //   setValue(
  //     "edit.branch",
  //     optionsBranch.find((op) => op.value == item.b_id)
  //   );
  //   setValue("edit.gpa", item.gpa);
  // };

  const getData = () => {
    getJdInternData()
      .then((res) => {
        const list = res.map((item) => {
          return {
            ...item,
            job_data: JSON.parse(item.job_data),
          };
        });

        console.log({ list });

        setLists(list);
        setFilterList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const displayDrawerDetail = (
    <ModalView
      isModaOpen={openDrawerDetail}
      setIsModalOpen={setOpenDrawerDetail}
    >
      <Box sx={{ width: "100%" }}>
        <div
          className="sheet padding-20mm  react-print-container"
          ref={componentRef}
        >
          <JobDetail itemSelected={itemSelected} />
        </div>
        <Button
          variant="outlined"
          onClick={handlePrint}
          id="section-to-not-print "
        >
          พิมพ์เอกสาร
        </Button>
      </Box>
    </ModalView>
  );

  const displayTable = (
    <>
      <div className="card-header">
        <div
          className="d-flex justify-content-between  flex-wrap"
          style={{ minHeight: "50px" }}
        >
          <h3 className="fw-bolder ">
            รายชื่อสถานประกอบการที่แจ้งรับนิสิตฝึกงานและสหกิจศึกษา ปีการศึกษา
            2565{" "}
          </h3>
          <div>
            <input
              type="text"
              style={{ maxWidth: 300 }}
              className="form-control"
              placeholder="ค้นหา"
              onChange={onSearchChange}
              value={searchTerm}
            />

            <div>{!!searchTerm && `พบ ${filterLists.length} ผลลัพธ์`}</div>
          </div>
        </div>
      </div>
      <div className="overflow-auto">
        <table
          id="datatables-dashboard-projects"
          className="table table-striped my-0 table-hover"
        >
          <thead>
            <tr className="text-nowrap table-primary">
              <th>#</th>
              <th>ชื่อสถานประกอบการ/หน่วยงาน</th>
              <th>สาขาที่รับ</th>
              <th>ผู้ประสานงาน</th>
              {/* <th>เบอร์โทร</th> */}
            </tr>
          </thead>
          <tbody>
            {!!filterLists.length &&
              filterLists.map((el, elIndex) => {
                return (
                  <tr
                    key={elIndex}
                    style={{ cursor: "pointer" }}
                    onClick={() => onOpenDetail(el)}
                  >
                    <td>{elIndex + 1}</td>
                    <td>
                      <div>
                        <span className="badge bg-primary fw-bolder">
                          {el.job_data.company.company_thainame}
                        </span>
                      </div>
                      <small>
                        {el.job_data.company.address}{" "}
                        {el.job_data.company.sub_district}{" "}
                        {el.job_data.company.district}{" "}
                        {el.job_data.company.province}{" "}
                        {el.job_data.company.zip_code}
                      </small>
                    </td>
                    <td>
                      {el.job_data.branchs
                        .filter((item) => item.allow)
                        .map((data) => (
                          <div>
                            <span
                              className="badge rounded-0 text-white fw-bolder"
                              style={{ background: "#8ab702" }}
                            >
                              {" "}
                              {matchOptions(optionsBranch, data.b_id)}{" "}
                            </span>
                            <span
                              className="badge rounded-0 text-white"
                              style={{ background: "#4c5151" }}
                            >
                              {" "}
                              {data.intern_qty} ตำแหน่ง
                            </span>
                          </div>
                        ))}
                    </td>

                    <td>
                      {" "}
                      <span className="fw-bolder">
                        {" "}
                        {el.job_data.contact.full_name}{" "}
                      </span>
                      <p>
                        <i class="fa-sharp fa-solid fa-phone"></i>{" "}
                        {el.job_data.contact.contact_availabel.type === "2"
                          ? el.job_data.contact.contact_availabel.type
                          : el.job_data.contact.tel}{" "}
                        <i class="fa-sharp fa-solid fa-envelope"></i>{" "}
                        {el.job_data.contact.contact_availabel.type === "2"
                          ? el.job_data.contact.contact_availabel.type
                          : el.job_data.contact.email}
                      </p>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </>
  );

  return (
    <div>
      <div className="main">
        <main className="content">
          <div className="container-fluid p-0">
            <div className="card flex-fill">{displayTable}</div>
          </div>
        </main>
      </div>
      {displayDrawerDetail}
    </div>
  );
};

export default JobRequest;
